/** Sub-10s steps read as 0.4s / 3.2s; longer ones lose the decimal. */
export const formatDuration = (seconds: number): string =>
  seconds < 10 ? `${seconds.toFixed(1)}s` : `${Math.round(seconds)}s`;
